export default __webpack_public_path__ + "af82785db78d2353571714f93252a391.woff2";